import styled from "@emotion/styled";
import { Grid, FormLabel, Typography } from "@mui/material";
import { textFormatter } from "@shared/utils/text-formatter";

type Props = {
  email: string;
  mlsId: string;
  name: string;
  phoneNumber: string | null;
  officeName: string;
};

const Container = styled(Grid)`
  width: 100%;
  p {
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    font-size: ${(p) => p.theme.text.fontSizes.m};
  }
`;

export const UserInfoSummary = (props: Props) => {
  const { name, mlsId, phoneNumber, email, officeName } = props;
  return (
    <Container container mb={4} rowSpacing={1} columnSpacing={3}>
      <Grid item sm={7} xs={7}>
        <FormLabel>Full name</FormLabel>
        <Typography>{textFormatter.valueToText(name)}</Typography>
      </Grid>
      <Grid item sm={5} xs={5}>
        <FormLabel>License number</FormLabel>
        <Typography>{textFormatter.valueToText(mlsId)}</Typography>
      </Grid>

      <Grid item sm={7} xs={7}>
        <FormLabel>Phone number</FormLabel>
        <Typography>{textFormatter.formatPhoneNumber(phoneNumber)}</Typography>
      </Grid>
      <Grid item sm={5} xs={5}>
        <FormLabel>Brokerage name</FormLabel>
        <Typography>{textFormatter.valueToText(officeName)}</Typography>
      </Grid>

      <Grid item sm={7} xs={12}>
        <FormLabel>E-mail</FormLabel>
        <Typography>{textFormatter.valueToText(email)}</Typography>
      </Grid>
    </Container>
  );
};
